<template>
  <div id="contact-form" class="section padding-bottom-big over-hide">
    <div class="container">
      <div class="row justify-content-center px-4 px-xl-2">
        <transition name="popup">
          <div key="form" v-if="!passwordResetSuccess" class="col-12">
            <form @submit.prevent="login" class="row ajax-form">
              <div class="col-12">
                <p v-show="error" class="mb-4">{{ error }}</p>
                <input
                  v-model.trim="form.email"
                  name="email"
                  type="email"
                  placeholder="E-Mail: *"
                  autocomplete="email"
                />
              </div>
              <div class="col-md-12 mt-4 password-input">
                <input
                  v-model.trim="form.password"
                  name="password"
                  :type="hidePassword ? 'password' : 'text'"
                  placeholder="What's the Magic Word?: *"
                  autocomplete="current-password"
                />
                <svg
                  @click="hidePassword = !hidePassword"
                  class="toggle-password"
                  width="32pt"
                  height="32pt"
                  viewBox="0 0 32 32"
                >
                  <path
                    v-if="hidePassword"
                    d="M 16 3 C 12.15625 3 9 6.15625 9 10 L 9 13 L 6 13 L 6 29 L 26 29 L 26 13 L 23 13 L 23 10 C 23 6.15625 19.84375 3 16 3 Z M 16 5 C 18.753906 5 21 7.246094 21 10 L 21 13 L 11 13 L 11 10 C 11 7.246094 13.246094 5 16 5 Z M 8 15 L 24 15 L 24 27 L 8 27 Z "
                  />
                  <path
                    v-else
                    d="M 16 3 C 12.964844 3 10.414063 4.964844 9.375 7.625 L 11.21875 8.375 C 11.976563 6.433594 13.835938 5 16 5 C 18.753906 5 21 7.246094 21 10 L 21 13 L 6 13 L 6 29 L 26 29 L 26 13 L 23 13 L 23 10 C 23 6.15625 19.84375 3 16 3 Z M 8 15 L 24 15 L 24 27 L 8 27 Z "
                  />
                </svg>
              </div>
              <div class="col-md-12 mt-4">
                <button :class="{ loading: loading }" type="submit">
                  <span>{{ loading ? "Signing In" : "Sign In" }}</span>
                </button>
                <a @click.prevent="resetPassword" href="#" class="d-block mt-4"
                  >Forgot Your Password?</a
                >
              </div>
            </form>
          </div>
          <div key="passwordModal" v-else class="col-12">
            <div class="reset-modal alert alert-dark">
              <a
                class="close-button ml-auto mb-3"
                @click="passwordResetSuccess = false"
                >X</a
              >
              <h4 class="alert-heading">Your Password has been Reset!</h4>
              <hr />
              <p>Check your email for a link to reset your password</p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "../firebase-config";
export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      hidePassword: true,
      passwordResetSuccess: false,
      loading: false,
      error: null
    };
  },
  methods: {
    async login() {
      this.error = "";
      this.loading = true;
      try {
        const user = await auth.signInWithEmailAndPassword(
          this.form.email,
          this.form.password
        );
        this.$store.commit("setCurrentUser", user.user);
        this.$store.dispatch("fetchUserProfile");
        this.$router.push({ name: "Dashboard" });
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async resetPassword() {
      this.loading = true;
      try {
        await auth.sendPasswordResetEmail(this.form.email);
        this.form.email = "";
        this.passwordResetSuccess = true;
      } catch (error) {
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-info {
  a {
    display: block;
    color: #c4c3ca;

    &:hover {
      text-decoration: none;
      color: $primary;
    }
  }
}

.ajax-form {
  transition: transform 0.5s;
  transform-origin: center;

  input {
    position: relative;
    width: 100%;
    padding: 20px 20px;
    font-weight: 400;
    letter-spacing: 1px;
    font-size: 15px;
    line-height: 1.7;
    background-color: #14151a;
    color: #fff;
    border: none;
    text-align: left;
    cursor: text;
    transition: all 250ms linear;

    &:active,
    &:hover {
      color: #ccc;
    }

    &:focus {
      outline: none !important;
    }

    &::placeholder {
      font-size: 15px;
      letter-spacing: 1px;
      color: rgba(255, 255, 255, 0.4);
      font-weight: 700;
    }
  }

  .password-input {
    position: relative;

    .toggle-password {
      position: absolute;
      z-index: 100;
      height: 30%;
      color: $dark;
      top: 50%;
      right: 3%;
      transform: translateY(-50%);
      fill: $primary;
      cursor: pointer;
    }
  }
}

.reset-modal {
  transition: transform 0.5s;
  transform-origin: center;
  .close-button {
    display: block;
    font-weight: 900;
    font-size: 0.75rem;
    color: #333;
    background: whitesmoke;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
  }
}
.popup-enter,
.popup-leave-to {
  transform: scale(0);
  opacity: 0;
}

.popup-enter-active {
  transition: all 0.3s ease;
  transition-delay: 0.3s;
}

.popup-leave-active {
  transition: all 0.3s ease;
}
</style>
